module.exports = __webpack_public_path__ + "fonts/Inter-900-latin-ext83.1ad231a.woff2";